export const SET_ONLINE = 'setOnline';
export const SET_OFFLINE = 'setOffline';
export const SET_CONNECTED = 'setConnected';
